import { render, staticRenderFns } from "./JsonViewerModal.vue?vue&type=template&id=23b55fff&scoped=true"
import script from "./JsonViewerModal.vue?vue&type=script&lang=ts"
export * from "./JsonViewerModal.vue?vue&type=script&lang=ts"
import style0 from "./JsonViewerModal.vue?vue&type=style&index=0&id=23b55fff&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b55fff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b55fff')) {
      api.createRecord('23b55fff', component.options)
    } else {
      api.reload('23b55fff', component.options)
    }
    module.hot.accept("./JsonViewerModal.vue?vue&type=template&id=23b55fff&scoped=true", function () {
      api.rerender('23b55fff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/JsonViewerModal.vue"
export default component.exports